/* JOLI POT, configurateur : aperçu du pot à l'échelle de la taille choisie (assets/jp-configurateur-echelle.js, 24/10/2026).
   Chargé par layout/theme.liquid sur les fiches produit, après assets/jp-configurateur.js (118 Ko, trop gros pour l'API, inchangé).
   Même règle que les fiches d'occasion (assets/jp-occasion-apercu.js, constante ECHELLE) : le dessin du pot ne change pas de taille,
   donc plus le pot est petit, plus le message paraît gros (peu de marge) ; plus le pot est grand, plus il y a d'espace autour.
   Avant : lettres de 14, 15 puis 16 pour 8, 11 et 13 cm (échelle inversée). Le configurateur dessine, ce script refait aussitôt
   le texte, le cœur et la signature avec la règle d'échelle, en gardant son dessin du pot (blanc, terra, doré, bougie, coupelle).
   Non concernés : Flora (une seule taille), kit et aperçus sans taille, fiches d'occasion (déjà traitées par jp-occasion-apercu.js). */
(function () {
  var ECHELLE = { margeX: [5, 34], margeY: [3, 28], lettres: 21, mini: 6 };
  function cadre(cm) {
    var r = Math.max(0.5, Math.min(1, 8 / (cm || 11)));
    return { mx: ECHELLE.margeX[0] + (1 - r) * ECHELLE.margeX[1], my: ECHELLE.margeY[0] + (1 - r) * ECHELLE.margeY[1], cap: ECHELLE.lettres * r };
  }
  var TOP = 76, H = 88, G0 = 56, D0 = 144, PENTE = 11, HAUT = 80, BAS = 158;
  function bords(y) { var dx = (y - TOP) * PENTE / H; return { g: G0 + dx, d: D0 - dx }; }
  var POL = "Sacramento, 'Brush Script MT', cursive", ctx = null;
  function largeur(t) {
    if (!ctx) { try { ctx = document.createElement('canvas').getContext('2d'); } catch (e) {} }
    if (!ctx) return t.length * 0.42;
    ctx.font = '10px ' + POL; return ctx.measureText(t).width / 10;
  }
  function coupes(m, k) {
    var res = [];
    (function r(d, k2, acc) {
      if (k2 === 1) { res.push(acc.concat([m.slice(d).join(' ')])); return; }
      for (var i = d + 1; i <= m.length - k2 + 1; i++) r(i, k2 - 1, acc.concat([m.slice(d, i).join(' ')]));
    })(0, k, []);
    return res;
  }
  var LIES = ['pour','et','de','du','des','à','au','aux','le','la','les','un','une','en','que','qui','mon','ma','mes','ton','ta','tes','son','sa','ses','avec','sans','sur','par','dans','ou','mais','nos','vos','notre','votre','ce','cette'];
  function equilibrer(ligne, larg, fs, forcer) {
    var m = ligne.split(/\s+/).filter(Boolean); if (!m.length) return [];
    var secours = null, secoursMax = Infinity;
    for (var k = 1; k <= Math.min(3, m.length); k++) {
      var choix = null, cout = Infinity;
      coupes(m, k).forEach(function (l) {
        var ws = l.map(function (x) { return largeur(x) * fs; }), mx = Math.max.apply(null, ws);
        if (mx < secoursMax) { secoursMax = mx; secours = l; }
        if (mx > larg) return;
        var moy = ws.reduce(function (a, b) { return a + b; }, 0) / k;
        var c = mx + ws.reduce(function (a, b) { return a + Math.abs(b - moy); }, 0) * 0.3;
        if (k > 1 && m.length > k && l[k - 1].indexOf(' ') < 0) c += larg;
        for (var z = 0; z < k - 1; z++) { var dern = l[z].split(' ').pop().toLowerCase(); if (LIES.indexOf(dern) > -1 || /['’]$/.test(dern)) c += larg * 0.6; }
        if (c < cout) { cout = c; choix = l; }
      });
      if (choix) return choix;
    }
    return forcer ? secours : null;
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var COEUR_D = 'c-1.2-1.2-6-4.2-6-7.2 0-1.9 1.2-3.1 3.1-3.1 1.2 0 2.2.7 2.9 1.9.7-1.2 1.7-1.9 2.9-1.9 1.9 0 3.1 1.2 3.1 3.1 0 3-4.8 6-6 7.2z', NS = 0;

  function refaire(cible) {
    var o = cible.querySelector('svg');
    if (!o || o.hasAttribute('data-jpce') || o.hasAttribute('data-jpoe') || cible.closest('.jp-mode-occasion')) return '';
    var html = cible.innerHTML;
    if (/#d23a3a|M72 96h56/.test(html)) return '';
    var bloc = cible.closest('.jp-ap'), leg = bloc ? bloc.querySelector('.jp-ap__legende') : null;
    var cm = +(((leg && leg.textContent) || '').match(/(\d+)\s*cm/) || [0, 0])[1];
    if ([8, 11, 13].indexOf(cm) < 0) return '';
    var t = document.getElementById('votre-texte-personnalise'), sgEl = document.getElementById('jp-ap-sig');
    var v = t ? t.value.replace(/\r/g, '').trim() : '', sg = sgEl ? sgEl.value.trim() : '';
    if (!v) return '';
    var iD = html.indexOf('</defs>'), iT = html.indexOf('<text');
    if (iD < 0 || iT < iD) return '';
    var dessinPot = html.slice(iD + 7, iT);
    var encre = (html.match(/<text[^>]* fill="(#[0-9a-fA-F]{3,6})"/) || [0, '#1d1a17'])[1];
    var mc = html.match(/translate\(-100 0\)" d="M100 0[^"]*" fill="(#[0-9a-fA-F]{3,6})"/), coeur = !!mc, couleurCoeur = mc ? mc[1] : '#c8102e';
    var z = cadre(cm), brut = v.split('\n').map(function (x) { return x.trim(); }).filter(Boolean).slice(0, 6);
    var haut = HAUT + z.my, bas = BAS - z.my, fs, lh, lignes = [], ech, ecart, fsS, total, ok = false;
    for (fs = z.cap; fs >= ECHELLE.mini; fs -= 0.5) {
      var dernier = fs - 0.5 < ECHELLE.mini;
      lh = fs * 0.98;
      ech = Math.max(0.3, Math.min(0.8, fs / 28));
      ecart = coeur ? Math.max(2.5, fs * 0.4) : 0;
      fsS = sg ? Math.min(fs * 0.62, 13) : 0;
      var yMil = (haut + bas) / 2, lm = bords(yMil).d - bords(yMil).g - 2 * z.mx;
      lignes = []; ok = true;
      brut.forEach(function (b) { var lb = equilibrer(b, lm, fs, dernier); if (!lb) ok = false; else lb.forEach(function (x) { lignes.push(x); }); });
      if (!ok) continue;
      total = lignes.length * lh + (coeur ? ecart + 10.3 * ech : 0) + (sg ? fsS + 3 : 0);
      if (total > bas - haut && !dernier) { ok = false; continue; }
      var y = haut + (bas - haut - total) / 2 + lh * 0.72;
      for (var k = 0; k < lignes.length; k++) { var bd = bords(y + k * lh); if (largeur(lignes[k]) * fs > bd.d - bd.g - 2 * z.mx) { ok = false; break; } }
      if (ok && sg && largeur(sg) * fsS > lm) ok = false;
      if (ok || dernier) break;
    }
    var y0 = haut + (bas - haut - total) / 2 + lh * 0.72, id = 'jpceap' + (++NS), s = '';
    s += '<svg data-jpce="1" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="' + esc(v) + '"><defs>';
    lignes.forEach(function (x, k) { var yy = y0 + k * lh, bd = bords(yy); s += '<path id="' + id + k + '" d="M' + (bd.g - 6).toFixed(1) + ' ' + yy.toFixed(1) + ' Q100 ' + (yy + 4).toFixed(1) + ' ' + (bd.d + 6).toFixed(1) + ' ' + yy.toFixed(1) + '"/>'; });
    s += '</defs>' + dessinPot;
    var pol = POL.replace(/"/g, '');
    lignes.forEach(function (x, k) {
      s += '<text font-family="' + pol + '" font-size="' + fs.toFixed(1) + '" font-weight="700" fill="' + encre + '" text-anchor="middle"><textPath href="#' + id + k + '" startOffset="50%">' + esc(x) + '</textPath></text>';
    });
    var yb = y0 + (lignes.length - 1) * lh + fs * 0.32;
    if (coeur) { yb += ecart + 10.3 * ech; s += '<path transform="translate(100 ' + yb.toFixed(1) + ') scale(' + ech.toFixed(3) + ') translate(-100 0)" d="M100 0' + COEUR_D + '" fill="' + couleurCoeur + '"/>'; }
    if (sg) { yb += fsS + 2; s += '<text x="100" y="' + yb.toFixed(1) + '" font-family="' + pol + '" font-size="' + fsS.toFixed(1) + '" fill="' + encre + '" text-anchor="middle">' + esc(sg) + '</text>'; }
    return s + '</svg>';
  }

  var suivies = [];
  function brancher(c) {
    if (suivies.indexOf(c) > -1) return;
    var f = c.closest('form');
    if (f && f.classList.contains('jp-mode-occasion')) return;
    suivies.push(c);
    var enCours = false;
    function maj() {
      if (enCours) return;
      enCours = true;
      try { var s = refaire(c); if (s) c.innerHTML = s; } catch (e) {}
      enCours = false;
    }
    new MutationObserver(maj).observe(c, { childList: true });
    maj();
  }
  function chercher() { document.querySelectorAll('.jp-ap .jp-ap__svg').forEach(brancher); return suivies.length > 0; }
  if (!chercher() && window.MutationObserver) {
    var obs = new MutationObserver(function () { if (chercher()) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }
})();
